import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: 'IndustryToInterests',
  props: {
    industries: {
      required: false,
      type: [Array, Object]
    },
    value: {
      required: false,
      type: [Array, Object]
    },
    industryLabel: {
      default: 'Job',
      required: false,
      type: String
    },
    interestLabel: {
      default: 'Job',
      required: false,
      type: String
    }
  },
  setup: function setup() {
    var addedIndustries = reactive([{
      industry: null,
      fields_of_interest: []
    }]);
    var interests = reactive([]);
    return {
      addedIndustries: addedIndustries,
      interests: interests
    };
  },
  watch: {
    value: function value(_value) {
      this.updateValue();
    }
  },
  created: function created() {
    if (this.value) {
      this.updateValue();
    }
  },
  methods: {
    selectedIndustries: function selectedIndustries(selected) {
      var excludingSelected = this.addedIndustries.map(function (object) {
        var _object$industry;

        return (_object$industry = object.industry) === null || _object$industry === void 0 ? void 0 : _object$industry.name;
      }) || [];
      return selected ? excludingSelected.filter(function (object) {
        return object !== selected.name;
      }) : excludingSelected;
    },
    showSelected: function showSelected(item) {
      var _this = this;

      var arr = JSON.parse(JSON.stringify(this.industries));
      return arr.map(function (object) {
        return _this.selectedIndustries(item).includes(object.name) ? _objectSpread(_objectSpread({}, object), {}, {
          $isDisabled: true
        }) : _objectSpread({}, object);
      });
    },
    fetchInterests: function fetchInterests(index) {
      var _this2 = this;

      this.addedIndustries[index].fields_of_interest = [];
      this.$store.dispatch('global/dropdown/getFieldsOfInterest', this.addedIndustries[index].industry.uuid).then(function (res) {
        _this2.$set(_this2.interests, index, res.data);
      });
      this.$emit('input', this.addedIndustries);
    },
    addIndustryObject: function addIndustryObject() {
      this.addedIndustries.push({
        industry: null,
        fields_of_interest: []
      });
      this.$emit('input', this.addedIndustries);
    },
    removeIndustryObject: function removeIndustryObject(object) {
      if (object.uuid) {
        this.$emit('delete', object.uuid);
      } else {
        var index = this.addedIndustries.indexOf(object);
        this.addedIndustries.splice(index, 1);
        this.interests.splice(index, 1);
        this.$emit('input', this.addedIndustries);
      }
    },
    addFieldOfInterest: function addFieldOfInterest(index, interest) {
      this.addedIndustries[index].fields_of_interest.push(interest);
      this.$emit('input', this.addedIndustries);
    },
    removeFieldOfInterest: function removeFieldOfInterest(index, interest) {
      var i = this.addedIndustries[index].fields_of_interest.indexOf(interest);
      this.addedIndustries[index].fields_of_interest.splice(i, 1);
      this.$emit('input', this.addedIndustries);
    },
    updateValue: function updateValue() {
      var _this3 = this;

      this.addedIndustries = this.value;

      if (this.addedIndustries && this.addedIndustries.length > 0) {
        this.addedIndustries.forEach(function (object, index) {
          var _this3$addedIndustrie;

          if ((_this3$addedIndustrie = _this3.addedIndustries[index].industry) !== null && _this3$addedIndustrie !== void 0 && _this3$addedIndustrie.uuid) {
            _this3.$store.dispatch('global/dropdown/getFieldsOfInterest', _this3.addedIndustries[index].industry.uuid).then(function (res) {
              _this3.$set(_this3.interests, index, res.data);
            });
          }
        });
      } else {
        this.addIndustryObject();
      }
    }
  }
};